import createMailFolderTableQuery from 'mini-mail-list-store/lib/utils/tables/createMailFolderTableQuery';
import type DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import mailStore from 'owa-mail-store/lib/store/Store';
import restoreFocusPivotState from '../utils/restoreFocusPivotState';
import { action } from 'satcheljs/lib/legacy';
import { getListViewType } from 'owa-mail-store/lib/utils/getListViewType';
import { lazySetRollupDismissState } from 'mini-mail-focused-inbox-rollup-store';
import { loadTableViewFromTableQuery } from 'mini-mail-list-actions';
import { safePerformanceMarkStart } from 'mini-performance';
import { signalWorkflowEvent } from 'mini-workflow-manager';
import type { LoadMailOptions } from 'mini-mail-list-actions/lib/schema/LoadMailOptions';
import {
    FOLDER_CHANGED,
    FOLDER_MAILS_LOADED,
} from 'mini-mail-workflow-tracking/lib/constants/ListViewWorkflowConstants';

export default action('selectFolder')(function selectFolder(folderId: string): Promise<void> {
    const previousFolderId = mailStore.folders.selectedFolderId;
    if (folderId === previousFolderId) {
        // Do not perform the rest of selecting folder logic when
        // user navigates to the current selected folder
        signalWorkflowEvent(FOLDER_MAILS_LOADED);
        return Promise.resolve();
    } else {
        signalWorkflowEvent(FOLDER_CHANGED);
        return selectFolderInternal(folderId);
    }
});

export function selectFolderInternal(
    inputFolderNameOrId: string,
    options?: LoadMailOptions
): Promise<void> {
    safePerformanceMarkStart('SelectFolderNodeToMailListContentRender');
    let distinguishedFolderId: string;
    let folderNameOrId = inputFolderNameOrId;

    // FolderId can be the real id of the folder or the distinguished name of it, like "inbox", "deletedItems", etc.
    if (folderNameOrId) {
        const distinguishedFolderName = folderNameOrId as DistinguishedFolderIdName;

        // The folderId is the name of a DistinguishedFolder. Grab the correct id.
        distinguishedFolderId = folderNameToId(distinguishedFolderName);
    }

    folderNameOrId = distinguishedFolderId ? distinguishedFolderId : folderNameOrId;
    mailStore.folders.selectedFolderId = folderNameOrId;

    let tableQuery = createMailFolderTableQuery(folderNameOrId);
    tableQuery = restoreFocusPivotState(tableQuery);
    tableQuery.listViewType = getListViewType();
    lazySetRollupDismissState.importAndExecute(false);

    // Assign the current focusedViewFilter in the selectedFocusedViewFilter
    mailStore.folders.selectedFocusedViewFilter = tableQuery.focusedViewFilter;
    return loadTableViewFromTableQuery(tableQuery, null, null, options);
}
